export class ItemTrackerProductsStocksMappingModel {
    public ID: number;
    public ProductId: number;
    public ProductSearchName: string;
    public ProductUniqueName: string;
    public IsOutDated: boolean;
    public Comment: string;
}
